// extracted by mini-css-extract-plugin
export var actions = "Hero-module--actions--874ea";
export var btn = "Hero-module--btn--d93c0";
export var btnOutlinePrimary = "Hero-module--btn-outline-primary--bc035";
export var btnPrimary = "Hero-module--btn-primary--f81ae";
export var content = "Hero-module--content--97b7b";
export var formSelect = "Hero-module--form-select--a0017";
export var hero = "Hero-module--hero--4f7df";
export var inner = "Hero-module--inner--8aa6d";
export var media = "Hero-module--media--0a7c6";
export var subtitle = "Hero-module--subtitle--05484";
export var title = "Hero-module--title--38948";